import Vue from 'vue'
import Router from 'vue-router'
import Root from '@/components/Root'
import WechatVoice from '@/components/module/WechatVoice'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Root',
      component: Root
    },
    {
      path: '/wechatvoice',
      name: 'WechatVoice',
      component: WechatVoice
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js